import { createFileRoute, Outlet } from '@tanstack/react-router';

import { notificationSettingsSearchSchema } from '@apps/web/routes/_app/settings/notifications/search';

export const Route = createFileRoute('/_app/settings/notifications')({
    validateSearch: notificationSettingsSearchSchema,
    component: NotificationsSettingsLayout,
});

function NotificationsSettingsLayout() {
    return <Outlet />;
}
